import { getEnvVar } from '@repo/utils'
import { getCookie, getLocalStorage } from '@repo/utils/client'
import { isE2E_Next } from '@repo/web3'

export const isDev = process.env.NEXT_PUBLIC_APP_ENV === 'dev'
export const isStaging = process.env.NEXT_PUBLIC_APP_ENV === 'staging'
export const isE2E = isE2E_Next

/**
 * The object to be passed as `env` in `getEnvVar` calls. Should include *at least*
 * all variables you wish to override in tests.
 *
 * @dev IMPORTANT: Variables must be referenced in the form
 * `process.env.SOME_NAME` in order for Next to inline them at build time.
 */
const env = {
  ANVIL_RPC_URLS: process.env.ANVIL_RPC_URLS,
  ALCHEMY_API_KEY: process.env.ALCHEMY_API_KEY,
  ERPC_SECRET: process.env.ERPC_SECRET,
  CHAINALYSIS_API_KEY: process.env.CHAINALYSIS_API_KEY,
  CACHE_INTERNAL_SECRET: process.env.CACHE_INTERNAL_SECRET,
  // The public, unauthenticated GraphQL endpoint. Deliberately NOT named `MORPHO_API_URL` (that name
  // means the dedicated REST instance elsewhere in the repo, and carries `MORPHO_API_SECRET`).
  MORPHO_API_GRAPHQL_URL: process.env.MORPHO_API_GRAPHQL_URL,
  // Surfaces custom Vercel environment names like `staging`; namespaces cache keys per environment.
  VERCEL_TARGET_ENV: process.env.VERCEL_TARGET_ENV,
  // Inlined for the browser by `next.config.ts`'s `env` block, not by the `NEXT_PUBLIC_` prefix —
  // Vercel injects both at build time. Read by the oRPC link's skew-protection header.
  VERCEL_DEPLOYMENT_ID: process.env.VERCEL_DEPLOYMENT_ID,
  VERCEL_SKEW_PROTECTION_ENABLED: process.env.VERCEL_SKEW_PROTECTION_ENABLED,
  NEXT_PUBLIC_REOWN_APP_ID: process.env.NEXT_PUBLIC_REOWN_APP_ID
} as const

export function getClientEnvVar(name: keyof typeof env) {
  return getEnvVar({
    name: name, // ⚠️ Keep explicit. Webpack does weird things to shorthand here 🤷‍♂️
    env,
    overrides: [getCookie, getLocalStorage],
    enableOverrides: isE2E
  })
}

export function getServerEnvVar(name: keyof typeof env) {
  return getEnvVar({
    name,
    env,
    overrides: [x => process.env[`E2E_${x}`]],
    enableOverrides: isE2E
  })
}
